// extracted by mini-css-extract-plugin
export default {"mainContainer":"Home_mainContainer__WvcQv","consigna2":"Home_consigna2__OhTO7","contain":"Home_contain__St-2i"};